export default {
  states: [],
  state: null,
  pagination: {}
}
